// eslint-disable-next-line import/prefer-default-export
export const muiFormHelperTextComponent = {
  styleOverrides: {
    root: ({ theme }) => ({
      margin: `${theme.spacing('SMALL')} ${theme.spacing('NONE')} ${theme.spacing('NONE')}`,
    }),
  },
};
